<template>
  <div class="grid-cell">
    <router-link :to="{name: 'CampaignDetailsSummary', query: {clientId: $route.query.clientId, companyId: $route.query.companyId, campaignId: data.projectId, userEmail: $route.query.userEmail} }">
      <span class="grid-cell--title">{{ data.title }}</span><br>
      <span class="grid-cell--subtitle">{{ data.subject }}</span>
    </router-link>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
}
.grid-cell {
  overflow: hidden;
  text-overflow: ellipsis;
}
.grid-cell--title {
  color: #000;
}
.grid-cell--subtitle {
  color: #666;
}
</style>
